import { useState } from 'react';

import { TMSEquipmentType } from 'types/Load';
import { MaybeUndef } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

type ServiceTypesResponse = TMSEquipmentType[];

type FetchServiceTypesOptions = {
  customerName?: MaybeUndef<string>;
};

export function useFetchServiceTypes(
  tmsID: number,
  options?: FetchServiceTypesOptions
) {
  const customerScoped = options !== undefined;
  const customerName = options?.customerName?.trim() ?? '';

  const [isRefreshing, setIsRefreshing] = useState(false);

  const key = !tmsID
    ? null
    : customerScoped && !customerName
      ? null
      : customerScoped
        ? `load/options/service-types?tmsID=${tmsID}&customerName=${encodeURIComponent(customerName)}`
        : `load/options/service-types?tmsID=${tmsID}`;

  const { data, error, isLoading, mutate } =
    useThrowableSWR<ServiceTypesResponse>(
      key,
      false // Don't retry on 404s
    );

  const refresh = async () => {
    setIsRefreshing(true);
    try {
      await mutate();
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    serviceTypes: data,
    isLoading: (Boolean(key) && isLoading) || isRefreshing,
    error,
    refresh,
  };
}
